import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import { formatAmount } from "@/utils/currency";

export interface DonutDatum {
  name: string;
  value: number;
  color: string;
}

interface CategoryChartProps {
  data: DonutDatum[];
  currencyCode?: string;
  height?: number;
}

export default function CategoryChart({
  data,
  currencyCode = "MXN",
  height = 220,
}: CategoryChartProps) {
  const total = data.reduce((s, d) => s + d.value, 0);

  return (
    <div>
      <div style={{ height }} className="w-full relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius="60%"
              outerRadius="85%"
              paddingAngle={3}
              strokeWidth={0}
            >
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value) => [
                formatAmount(Number(value), currencyCode),
                "Gasto",
              ]}
              contentStyle={{
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                fontSize: 12,
              }}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <p className="text-xs text-foreground-500">Total</p>
          <p className="text-lg font-heading font-bold text-foreground-950">
            {formatAmount(total, currencyCode)}
          </p>
        </div>
      </div>

      <ul className="mt-2 space-y-1.5">
        {data.map((d) => {
          const pct = total > 0 ? Math.round((d.value / total) * 100) : 0;
          return (
            <li key={d.name} className="flex items-center gap-2 text-sm">
              <span
                className="w-3 h-3 rounded-full shrink-0"
                style={{ backgroundColor: d.color }}
              />
              <span className="flex-1 truncate text-foreground-700">{d.name}</span>
              <span className="text-foreground-500 text-xs whitespace-nowrap">
                {pct}%
              </span>
              <span className="font-medium text-foreground-900 whitespace-nowrap">
                {formatAmount(d.value, currencyCode)}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}